import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import TextInput from '@components/form/TextInput';
import Modal from '@components/modal/Modal';
import React from 'react';
import { FullUser } from 'src/types/shared/User';
import useUpdateUserPassword from './hooks/useUpdateUserPassword';
import usePasswordValidation from 'lib/src/hooks/usePasswordValidation';

const UpdateUserPasswordModal: React.FC<UpdateUserModalProps> = ({
    user: {
        user: { id },
    },
}) => {
    const {
        formState: { password, confirmPassword },
        handleChange,
        handleSubmit,
        isPosting,
        closeModal,
    } = useUpdateUserPassword(id);
    const { validatePassword, validateConfirmPassword } = usePasswordValidation(password);

    return (
        <Modal title="Update password" size="small" closeModal={closeModal}>
            <Form onCancel={closeModal} onSubmit={handleSubmit} isPosting={isPosting}>
                <FormRow>
                    <TextInput
                        required
                        type="password"
                        name="password"
                        value={password}
                        onChange={handleChange}
                        label="Password"
                        customValidate={validatePassword}
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        required
                        type="password"
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={handleChange}
                        customValidate={validateConfirmPassword}
                        label="Confirm password"
                    />
                </FormRow>
            </Form>
        </Modal>
    );
};

interface UpdateUserModalProps {
    user: FullUser;
}

export default UpdateUserPasswordModal;
